'use strict';

module.exports = function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/symbol-observable/ponyfill.js
 ** module id = 680
 ** module chunks = 0
 **/